/** Every failed call becomes an ApiError, so screens handle one error shape. */
export class ApiError extends Error {
    status;
    code;
    title;
    detail;
    requestId;
    fieldErrors;
    constructor(init) {
        super(init.detail ?? init.title);
        this.name = "ApiError";
        this.status = init.status;
        this.code = init.code;
        this.title = init.title;
        this.detail = init.detail;
        this.requestId = init.requestId;
        this.fieldErrors = init.fieldErrors ?? [];
    }
    /** Message for one form field, if the server rejected it. */
    fieldError(path) {
        return this.fieldErrors.find((e) => e.path === path)?.message;
    }
}
export const isApiError = (value) => value instanceof ApiError;
//# sourceMappingURL=api-error.js.map